import { createTheme } from "@mui/material/styles";

const theme = createTheme({
  palette: {
    mode: "light",
    primary: {
      main: "#1b3670",
    },
  },
  components: {
    MuiFormHelperText: {
      styleOverrides: {
        root: {
          "&.Mui-error": {
            position: "absolute",
            bottom: "-20px",
            left: 0,
          },
        },
      },
    },
  },
});

export default theme;
